export default __webpack_public_path__ + "static/media/border-vertical-3.acc6c749.webp";